(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@babel/runtime/helpers/slicedToArray'), require('web3'), require('bignumber.js')) :
  typeof define === 'function' && define.amd ? define(['exports', '@babel/runtime/helpers/slicedToArray', 'web3', 'bignumber.js'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global['rbank-utils'] = {}, global._slicedToArray, global.Web3, global.BigNumber));
}(this, (function (exports, _slicedToArray, Web3, BigNumber) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
  var Web3__default = /*#__PURE__*/_interopDefaultLegacy(Web3);
  var BigNumber__default = /*#__PURE__*/_interopDefaultLegacy(BigNumber);

  var web3 = new Web3__default['default'](Web3__default['default'].givenProvider || 'http://127.0.0.1:8545');
  var Web3Utils = Web3__default['default'];
  var getEventualChainId = function getEventualChainId() {
    return web3.eth.getChainId();
  };
  var BN = BigNumber__default['default'];
  var internalSend = function internalSend(signature, from) {
    return new Promise(function (resolve, reject) {
      signature.estimateGas({
        from: from
      }).then(function (gas) {
        return signature.send({
          from: from,
          gas: gas
        });
      }).then(resolve).catch(reject);
    });
  };
  var send = function send(signature) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return new Promise(function (resolve, reject) {
      if (from) {
        internalSend(signature, from).then(resolve).catch(reject);
      } else {
        web3.eth.getAccounts().then(function (_ref) {
          var _ref2 = _slicedToArray__default['default'](_ref, 1),
              account = _ref2[0];
          return internalSend(signature, account);
        }).then(resolve).catch(reject);
      }
    });
  };
  var PERIOD_DAY = 'day';
  var PERIOD_WEEK = 'week';
  var PERIOD_MONTH = 'month';
  var PERIOD_YEAR = 'year';

  exports.BN = BN;
  exports.PERIOD_DAY = PERIOD_DAY;
  exports.PERIOD_MONTH = PERIOD_MONTH;
  exports.PERIOD_WEEK = PERIOD_WEEK;
  exports.PERIOD_YEAR = PERIOD_YEAR;
  exports.Web3Utils = Web3Utils;
  exports.getEventualChainId = getEventualChainId;
  exports.send = send;
  exports.web3 = web3;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
